'use strict';

/**
 * @ngdoc function
 * @name 360StoreAngularApp.controller:ReportsSalesVersusTimeCtrl
 * @description
 * # ReportsSalesVersusTimeCtrl
 * Controller of the 360StoreAngularApp
 */
angular.module('360StoreAngularApp')
  .controller('ReportsSalesVersusTimeCtrl', function ($scope, api) {
	  $scope.buildSalesVersusTimeReport = async () => {
		  $scope.results = await api.runReport('sales-versus-time', {});
	  };
  });
